module.exports = {
      id: "ic-close-bold-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-close-bold-usage",
      toString: function () {
        return this.url;
      }
    }